<template>
    <div v-if="temporaryProducts" class="selected-products">
        <div v-for="product in temporaryProducts">
            <modal :result="product"></modal>
        </div>
        <h4 v-show="noneSelected">None Selected</h4>
    </div>

</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import SelectedModal from 'vue/submittal-manager/mechanical/sidebar/_selected-modal';
    import _ from 'lodash';

    export default {
        components: {
            'modal': SelectedModal
        },
        computed: {
            noneSelected() {
                return this.temporaryProducts.length < 1
            }
        },
        props: ['temporaryProducts']
    }
</script>
